import { createAction, createRequestTypes, createRequestActions } from './utils';
import keyMirror from 'react-utils/keyMirror';
export const PermissionActionTypes = keyMirror({
  LOAD_PERMISSIONS: null
});
export const FETCH_PERMISSIONS = 'FETCH_PERMISSIONS';
export const FetchPermissionsActionTypes = createRequestTypes(FETCH_PERMISSIONS);
export const FetchPermissions = createRequestActions(FetchPermissionsActionTypes);
export const loadPermissions = () => createAction(PermissionActionTypes.LOAD_PERMISSIONS);